<template>
    <div :class="b()" id="disabledBlockWrap">
        <i class="fa fa-spinner fa-spin spinner-center"></i>

        <div class="row" v-if="this.buying" id="disabledBlock">
            <div class="col-md-3">

                <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                        <h3 class="profile-username text-center">{{ this.buying.endSumBuying | pricePrecision }} <span>руб</span></h3>
                        <p class="text-muted text-center">общая сумма закупки</p>
                        <ul class="list-group list-group-unbordered mb-3">
                            <li class="list-group-item">
                                <b>Дата завершения</b> <a class="float-right">{{ this.buying.offerDate }}</a>
                            </li>
                            <li class="list-group-item">
                                <b>Ответственный</b>
                                <template v-if="this.buying.responsible.accountManager.name">
                                    <span class="float-right">{{ this.buying.responsible.accountManager.name }}</span>
                                </template>
                                <template v-else>
                                    <span class="float-right">-</span>
                                </template>

                            </li>
                            <li class="list-group-item">
                                <b>Статус</b> <a class="float-right">{{ this.buying.status }}</a>
                            </li>
                            <li class="list-group-item">
                                <b>Ссылка на площадке</b> <a :href="buyingLinkSite(this.buying.id, this.buying.type)" target="_blank" class="float-right">Перейти</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">Подробности закупки</h3>
                    </div>
                    <div class="card-body">
                        <strong><i class="far fa-clock "></i> Дата размещения закупки</strong>
                        <p class="text-muted">{{ this.buying.createDate }}</p>
                        <hr>

                        <strong><i class="fas fa-dollar-sign mr-1"></i> Начальная цена закупки</strong>
                        <p class="text-muted">{{ this.buying.startSumBuying | pricePrecision }} руб</p>
                        <hr>

                        <strong><i class="fas fa-percent mr-1"></i> Общий процент падения</strong>
                        <p class="text-muted">{{ this.buying.percentageReduction }}</p>

                        <strong><i class="far fa-folder-open mr-1"></i> Категория</strong>
                        <p class="text-muted">{{ this.buying.ancestor }}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="card">
                    <div class="card-header p-2">
                        <ul class="nav nav-pills">
                            <li class="nav-item"><a class="nav-link active" href="#products" data-toggle="tab">Покупатели и поставщики</a></li>                                    <li class="nav-item"><a class="nav-link" href="#timeline" data-toggle="tab">История</a></li>
                            <li class="nav-item"><a class="nav-link" href="#scores" data-toggle="tab">Прикрепленные счета</a></li>
                            <li class="nav-item"><a class="nav-link" href="#settings" data-toggle="tab">Настройки</a></li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <div class="tab-pane active" id="products">
                                <div class="card card-default" v-for="(product, index) in this.buying.products">
                                    <div class="card-header">
                                        <h3 class="card-title">{{ product.name }}</h3>

                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
                                            <button type="button" class="btn btn-tool" data-card-widget="remove"><i class="fas fa-remove"></i></button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-7 table-responsive">
                                                <table class="table table-striped table-valign-middle">
                                                    <thead>
                                                    <tr>
                                                        <th>Поставщик</th>
                                                        <th>Цена</th>
                                                        <th>Падение</th>
                                                        <th>Дата</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(offer, index) in product.offers">
                                                        <td>
                                                            <a :href="userLink(offer.user_id)">{{ offer.user_name }}</a>

                                                            <span v-if="index === 0" class="badge bg-success">win</span>
                                                        </td>
                                                        <td>{{ offer.price }}</td>
                                                        <td v-if="offer.percentageReductionPrev > 0">
                                                            <small class="text-danger mr-1">
                                                                <i class="fas fa-arrow-down"></i>
                                                                {{ offer.percentageReductionPrev }}%
                                                            </small>
                                                        </td>
                                                        <td v-else>
                                                            нмцк
                                                        </td>
                                                        <td>{{ offer.price_date }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>

                                                Общее падение: {{ product.percentageReduction }} %

                                            </div>
                                            <div class="col-md-5 table-responsive">
                                                <table class="table table-striped table-valign-middle">
                                                    <thead>
                                                    <tr>
                                                        <th>Покупатель</th>
                                                        <th>Кол-во</th>
                                                        <th>Сумма</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(distribution, index) in product.distributions">
                                                        <td>
                                                            <a :href="userLink(distribution.user_id)">{{ distribution.user_name }}</a>
                                                        </td>
                                                        <td>{{ distribution.qty }}</td>
                                                        <td>{{ distribution.qty * product.minOffer[0].price | pricePrecision }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>

                                                <strong>Итого:</strong> {{ getAllSumProductForDistribution(product.distributions, product.minOffer[0].price) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane" id="timeline">
                                <div class="card  card-tabs">
                                    <div class="card-header p-0 pt-1 border-bottom-0">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="custom-tabs-two-home-tab" data-toggle="pill" href="#entityAddComment" role="tab" aria-controls="custom-tabs-two-home" aria-selected="true">Новый комментарий</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="custom-tabs-two-profile-tab" data-toggle="pill" href="#entityAddTask" role="tab" aria-controls="custom-tabs-two-profile" aria-selected="false">Новая задача</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="card-body">
                                        <div class="tab-content">
                                            <div class="tab-pane fade active show" id="entityAddComment" role="tabpanel" aria-labelledby="custom-tabs-two-home-tab">
                                                <div class="form-group">
                                                    <textarea
                                                            @focus="onFocusButtonsComment"
                                                            v-model="historyCommentText"
                                                            class="form-control"
                                                            rows="1"
                                                            placeholder="Введите комментарий к закупке.."></textarea>
                                                </div>
                                                <div class="form-group" v-show="buttonsCommentFocused">
                                                    <button v-on:click="sendComment()" type="button" class="btn btn-primary">Отправить</button>
                                                </div>
                                            </div>
                                            <div class="tab-pane fade" id="entityAddTask" role="tabpanel" aria-labelledby="custom-tabs-two-profile-tab">
                                                Здесь можно будет поставить задачу сотруднику медвед по этой закупке... Но это уже будет в январе =)
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <history-entity
                                        :history="this.buying.history"
                                        :historyParams="this.buying.historyParams"
                                ></history-entity>
                            </div>

                            <div class="tab-pane" id="scores">
                                <div class="row">
                                    <div class="col-md-12">
                                        <template v-if="this.buying.scores.buyingScores.length">
                                            <scores
                                                :documents="this.buying.scores.buyingScores"
                                                action="detach"
                                            ></scores>
                                        </template>
                                        <template v-else>
                                           <p>Нажмите кнопку ниже, что бы прикрепить заранее загруженный счет.</p>
                                        </template>
                                    </div>
                                    <div class="col-sm-6">

                                        <button type="button" class="btn btn-info" data-toggle="modal" data-target="#selectScore">
                                            Выбрать счета
                                        </button>

                                        <div class="modal fade bd-example-modal-lg" id="selectScore" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div class="modal-dialog modal-lg" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="exampleModalLabel">Доступные счета</h5>
                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <template v-if="this.buying.scores.userScores.length">
                                                            <scores
                                                                :documents="this.buying.scores.userScores"
                                                                action="attach"
                                                                :buying-id="this.buyingId"
                                                                :buying-type="this.buyingType"
                                                            ></scores>
                                                        </template>
                                                        <template v-else>
                                                           У покупателей, принимающих участие в закупке, счетов не найдено! Перейдите в карточку пользователя и добавьте счет, затем вернитесь обратно и прикрипите его здесь.
                                                        </template>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">

                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane" id="settings">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Ответственный менеджер</label>
                                            <multiselect
                                                    v-model="accountManager"
                                                    selectLabel="Нажмите для добавления"
                                                    deselectLabel="Нажмите для удаления"
                                                    selectedLabel="Выбрано"
                                                    placeholder="Выберите одного ответственного за закупкой сотрудника"
                                                    label="name"
                                                    track-by="id"
                                                    :options="crmUsers"
                                                    :multiple="false"
                                                    :searchable="false"
                                                    @input="changeAccountUser"
                                            ></multiselect>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="disabledBlock" class="row" v-else>
            <div class="col-md-12">
                <p>Закупка не найдена</p>
            </div>
        </div>
    </div>
</template>

<script>

    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import Multiselect from 'vue-multiselect'

    import CrmService from '../../services/CrmService';

    import HistoryEntity from "./HistoryEntityComponent";
    import DocumentTable from "./DocumentTableComponent";

    Vue.component('multiselect', Multiselect);

    const COMPONENT_NAME = 'buying-show';

    export default {
        name: COMPONENT_NAME,
        components: {
            'multiselect': Multiselect,
            'history-entity': HistoryEntity,
            'scores': DocumentTable,
        },
        props: ['buyingId', 'buyingType'],
        data() {
            return {
                buying: null,
                accountManager: [],
                crmUsers: [],
                buttonsCommentFocused: false,

                actionData: {},
                historyCommentText: null,
            }
        },
        mounted() {

            // Добавляем общую блокировку
            this.blockedWrapPage(true);

            this.updateComponent();
        },
        methods: {
            updateComponent() {
                this.getBuying();
            },
            async getBuying() {
                try {
                    let response = await CrmService.getBuying(this.buyingId, this.buyingType);
                    if (response.success) {
                        this.buying = response.buying;

                        this.accountManager = response.buying.responsible.accountManager;
                        this.crmUsers = response.buying.responsible.crmUsers;

                        // Убираем блокировку всего блока
                        this.blockedWrapPage(false);
                    }else{
                        alert(response.error.message)
                    }
                } catch (e) {
                    console.error(e);
                }
            },
            getAllSumProductForDistribution(distribution, price) {
                let sum = 0;
                for (let key in distribution) {
                    sum += distribution[key].qty;
                }
                let result = sum * price | this.pricePrecision;
                return result + ' рублей';
            },

            // Смена ответственного
            async changeAccountUser (value) {
                let response = await CrmService.setBuyingAccountManager(this.buyingId, this.buyingType, value);
                if (response.success) {
                    this.$message('Фильтр обновлён');

                    this.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Смена фокуса в блоке отправки комментария
            onFocusButtonsComment(event) {
                this.buttonsCommentFocused = true;
                event.target.rows = 4;
            },
            onBlurButtonsComment() {
                this.buttonsCommentFocused = false;
            },

            // Отправка комментария к закупке
            async sendComment() {

                // Если нет коммента
                if(!this.historyCommentText) {
                    alert('Введите комментарий');
                    return;
                }

                this.actionData['commentText'] = this.historyCommentText;

                let response = await CrmService.sendHistoryEntity(this.buying.entityType, this.buying.id, this.actionData);
                if (response) {
                    this.$message('Успешное выполнение');
                    this.historyCommentText = null;
                    this.actionData = {};
                    this.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Блокируем общий фон при загрузке
            blockedWrapPage(method) {
                if(method === true) {
                    $('#disabledBlock').addClass('disabled');
                    $('#disabledBlockWrap .spinner-center').show();
                }else{
                    $('#disabledBlock').removeClass('disabled');
                    $('#disabledBlockWrap .spinner-center').hide();
                }
            },

            // Ссылка на профиль пользователя
            userLink(id) {
                return `/admin/users/show?id=${id}`;
            },

            // Ссылка на площадке на закупку
            buyingLinkSite(id, type) {
                return `/seller/buying?id=${id}&type=${type}`;
            },
        },
        filters: {
            pricePrecision: function (value) {
                if (!value) value = '';
                value = new Number(value);
                value = value.toFixed(2);

                return value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .buying-show {

        .profile-username {
            font-size: 40px;

            span {
                font-size: 21px;
                color: #919191;
            }
        }
    }

    #disabledBlockWrap {
        position: relative;

        #disabledBlock.disabled {
            opacity: 0;
            pointer-events: none;
        }

        .spinner-center {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: none;
            font-size: 40px;
        }
    }
</style>